/* eslint-disable */

<template>
    <div>
        <BasicCard :title="`Anagrafica`">
            <ClientRegistryEdit
                ref="registry_form"
                :o_data="registry_data"
                :locations="[]"
                v-on:valid_registry="registryValiditationChanged"
                >
            </ClientRegistryEdit>
            <v-alert v-if="registry_dup" type="warning">
                Attenzione alle possibili duplicazioni di Ragione sociale e partita IVA
            </v-alert>
        </BasicCard>
        <!-- CONTACT MANAGEMENT -->
        <BasicCard v-bind:title="`Rubrica`">
            <template v-slot:action>
                <v-btn text @click.stop="editContact(null,-1)" class="suggestion white--text"><v-icon small class="ma-1">add_box</v-icon>contatto</v-btn>
            </template>
            <v-card class="elevation-1 ma-0 pa-0 mt-0" v-if="contacts.length==0" style="position: relative;" >
                <span class="body-1 ma-2">Nessun contatto presente<sup>(*obbligatorio)</sup></span>
            </v-card>
            <v-card class="elevation-1 ma-0 pa-0 mt-0" v-for="(contact, idx) in contacts" :key="contact.id" style="position: relative;" >
                 <v-container class="py-1">
                    <v-row no-gutters class="d-flex align-start">
                        <v-col cols="10" class="d-flex align-start justify-center pb-1 flex-grow-1">
                            <v-icon class="d-flex flex-shrink-1 flex-grow-0 pr-2" small>contacts</v-icon>
                            <div class="d-flex flex-shrink-0 flex-grow-1">
                                <b>{{ contact.name }}</b> - 
                                <i>email: <b>{{ contact.email }}</b></i>,
                                <i>telefono: <b>{{ contact.phone }}</b></i>
                            </div>    
                        </v-col>
                        <v-col cols="2" class="d-flex align-start justify-end">
                            <v-btn color="action" class="ma-1" small fab @click.stop="editContact(contact.id, idx)"><v-icon>edit</v-icon></v-btn>
                            <v-btn color="action" class="ma-1" small fab @click.stop="openDeleteContactConfirm" :disabled="contacts.length==1"><v-icon>delete</v-icon></v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </BasicCard>
                
        <BasicCard v-if="createLocation" :title="`Sede`">
            <template v-slot:action>
                <div class="d-flex flex-nowrap"><v-checkbox label="Sede legale" v-model="is_registered_office" /></div>
            </template>
            <LocationForm
                ref="locationForm"
                v-bind:add_contact_enable="false"
                v-bind:enable_registered="is_registered_office"
                v-bind:contacts="contacts"
                v-on:validationChanged="locValidationChanged"
                />
        </BasicCard>
        <div class="d-flex justify-center my-4">
            <v-btn class="ma-2" @click="submit" color="primary" :disabled="!f_valid">
                Salva
            </v-btn>
            <v-btn class="ma-2" @click="close('cancel')" text>
                Annulla
            </v-btn>
        </div>
        <ConfirmDialog
                ref="contactDelete"
                v-bind:data="delete_contact_dialog.contact"
                v-on:close_dialog="closeDeleteContactDialog"
                v-on:confirm_result="onDeleteContactConfirm"/>
        <ContactDialog
            ref="contactEdit"
            v-on:contact_update="updateContact"
        />
    </div>        
</template>
<script>


import BasicCard from '../../components/utils/Basic_card.vue'
import LocationForm from './LocationForm'
import {getModel} from '../../utils/model'
import {f_rules} from '../../utils/commonUtils'
import ClientRegistryEdit from './ClientRegistryEdit'
import ConfirmDialog from '../../components/dialogs/ConfirmDialog'
import ContactDialog from "./ContactDialog"

export default {
    components:{LocationForm, BasicCard, ClientRegistryEdit, ConfirmDialog, ContactDialog},
    props: {
        back: {
            type: String,
            required: false,
            default: null
        },
        is_childcomponent: {
            type: Boolean,
            required: false,
            default: false
        },
        allowCreateLocation: {
            type: Boolean,
            required: false,
            default: true
        }
    },

    data() {
        return {
            valid: false,
            client: {},
            contacts:[],
            location: {},
            is_registered_office: false,
            billing_partners: [],
            createLocation: this.allowCreateLocation,
            rules: f_rules,
            delete_confirm: {
                index: null,
                dialog: false,
                message: "Sei sicuro di voler rimuovere il contatto selezionato?",
                choices: [
                    {key: "cancel", val: "annulla", mod: "success"},
                    {key: "delete", val: "elimina"}
                    ]
            },
            loc_valid: false,
            registry_valid: false,
            registry_dup: false,
            registry_data: {},
            delete_contact_dialog: {
                dialog: false,
                id: null,
                idx: -1,
                title: 'Elimina contatto',
                message: "Sei sicuro di voler rimuovere il contatto selezionato?",
                choices: [
                    {key: "cancel", val: "annulla", mod: "success"},
                    {key: "delete", val: "elimina"}
                    ]
            },
            selected_contact: null,
            selected_contact_idx: -1
        }
    },
   
    methods: {
        
        close(type){
            if(!this.is_childcomponent) {
                this.$router.push({path: this.back})
            } else {
                console.log('debug', type)
                switch(type) {
                    case 'cancel':
                        console.log('debug', type)
                        
                        this.$emit('close_dialog')
                        break;
                    case 'save':
                        this.$emit('add_client', this.client)
                        break;
                }
            }
        },
        async submit() {
            let docs_to_save = [this.client]
            if(this.client.is_partner){
                this.client.partner_list = []
            }
            Object.assign(this.client, this.$refs.registry_form.getData())
            if (this.contacts.length == 0) {
                this.valid = false;
                return
            }
            let valid_dup = await this.$refs.registry_form.isValid()
            if (!valid_dup) {
                this.registry_dup = true
                this.valid = false
                return
            }
            this.client.contacts = {}
            for (let contact of this.contacts) {
                console.log(contact)
                this.client.contacts[contact.id] = contact
            }
            this.client.updated_by = this.$store.state.user._id
            this.client.updated = (new Date()).getTime()
                    
            this.client.ref_orgs.push(this.$store.state.user.org_id)
            if (this.createLocation) {
                this.location = this.$refs.locationForm.getLocationData()
                this.location.complete = true
                this.location.ref_orgs.push(this.$store.state.user.org_id)
                this.client.complete = this.is_registered_office
                this.location.updated_by = this.$store.state.user._id
                this.location.updated = (new Date()).getTime()
            
                if (this.is_registered_office) {
                    this.client.registered_office = this.location._id
                }
                docs_to_save.push(this.location)
            }
            try {
                let res = await this.$store.state.$pouch.bulkDocs('registry', docs_to_save)
                this.close('save');
                this.contacts = []
            } catch(error) {
                console.log('error', error)
            }
        },
        initRegistryData() {
            this.registry_data= {
                '_id':this.client._id,
                'name':this.client.name,
                'piva': this.client.piva,
                'fiscal_code': this.client.fiscal_code,
                'pec': this.client.pec,
                'unique_code': this.client.unique_code,
                'is_partner': this.client.is_partner,
                'registered_office': this.client.registered_office
            }
            this.$refs.registry_form.resetValidation()

            // this.$set(this.registry_data, 'name', this.client.name)
            // this.$set(this.registry_data, 'piva', this.client.piva)
            // this.$set(this.registry_data, 'fiscal_code', this.client.fiscal_code)
            // this.$set(this.registry_data, 'pec', this.client.pec)
            // this.$set(this.registry_data, 'unique_code', this.client.unique_code)
            // this.$set(this.registry_data, 'is_partner', this.client.is_partner)
            // this.$set(this.registry_data, 'registered_office', this.client.registered_office)
            // console.log('initCLientREgistry', this.registry_data)
        },
        clear() {
            //this.$refs.form.reset();
        },
        createClient(){
            console.log("CREATE CLIENT")
            let Client = getModel("Client");
            this.client = Client({
                created_by: this.$store.state.user._id,
                updated_by: this.$store.state.user._id,
                updated: (new Date()).getTime()
            })
            // console.log("new client", this.client)
            this.initRegistryData()
            this.contacts = []
            if (this.allowCreateLocation) {
                this.is_registered_office = true
                let Location = getModel("Location");
                let loc = Location({
                    created_by: this.$store.state.user._id,
                    client_id: this.client._id,
                    //registered_office: true
                })
                this.$refs.locationForm.initData(loc, this.contacts, "Sede legale")
                this.$refs.locationForm.resetValidation()
            }
        },
        reset(){        // TODO manage the 'edit client' use-case
            this.createClient();            
        },
        locValidationChanged(valid){
            this.loc_valid = valid
        },
        registryValiditationChanged(valid) {
            this.registry_valid = valid
        },
        initClient(createLocation){
            this.createLocation = createLocation
        },/////////////// CONTACT //////////////////////
        editContact(id, idx){
            this.selected_contact_idx = idx
            if (idx != -1) {
                console.log(this.contacts[id])
                this.selected_contact = this.contacts[idx]
            } else {
                this.selected_contact = null
            }
            this.$refs.contactEdit.openDialog(this.selected_contact, this.selected_contact_idx)
        },
        async updateContact(contact, idx) {
            // console.log("UPDATE CONTACT",contact, idx)
            let updatedContact = _.cloneDeep(contact)
            if (idx == -1) {
                this.$set(this.contacts, this.contacts.length, updatedContact)
                this.$set(this.client.contacts, contact.id, updatedContact)
            } else {
                if (contact.id == this.contacts[idx].id) {
                    this.$set(this.contacts, idx, updatedContact)
                    //this.client.contacts[idx] = _.cloneDeep(contact)
                }
            }
            this.closeEditContactDialog()
        },
        async removeContact(id, idx) {
            //console.log('****', idx, id)
            
            let c_id = this.contacts[idx].id
            if (id == c_id) {
                let item = this.contacts.splice(idx, 1);
                // console.log('****', idx, item)
            }
        },
        openDeleteContactConfirm(){
            this.delete_contact_dialog.message = `Sei sicuro di voler rimuovere ${this.contacts[this.delete_contact_dialog.idx].name}?` 
            this.delete_contact_dialog.dialog = true;
        },
        async onDeleteContactConfirm(choice){
            if(choice == "delete"){
                await this.removeContact(this.delete_contact_dialog.id, this.delete_contact_dialog.idx)
            }
            this.delete_contact_dialog.dialog = false;
        },
        closeEditContactDialog(){
            this.$refs.contactEdit.closeDialog()
        },
        closeDeleteContactDialog(){
            this.delete_dialog.contact.dialog = false;
        }

    },
    computed: {
        f_valid() {
            // console.log("F Validity ", (this.contacts.length>0), this.registry_valid, this.loc_valid)
            return (this.contacts.length>0) && this.registry_valid && this.loc_valid
        },
        contactValidation(){
            return this.contacts.length>0
        }
    },
    mounted() {
        //console.log('************* new', this.new)
        if (!this.allowCreateLocation) {
            this.loc_valid = true
        }
        this.clear();
        this.reset();
    }
}
</script>

<style>

</style>
